<p *ngIf="title" class="ds-progress-bar-title" [innerHTML]="title"></p>
<div class="ds-progress-bar">
  <div class="ds-progress-bar-line {{color}}" [ngStyle]="{width: progressPercent + '%'}"></div>
</div>
<p *ngIf="label" class="ds-progress-bar-label">{{progressPercent + '% ' + label}}</p>
